import React, {useState} from "react";
import {
    ControlLabel,
    FormControl,
    FormGroup,
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import {
    changePassword,
} from "../utils/bedrockAPI";
import {
    getUser,
    removeUserSession
} from "../utils/Common";
import "./ChangePassword.css";

const MIN_PASSWORD_LENGTH = 8;

export default function ChangePassword(props) {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const passwordsMatch = confirmPassword.length > 0 && confirmPassword === newPassword;
    const passwordLongEnough = newPassword.length >= MIN_PASSWORD_LENGTH;
    const canSubmit = oldPassword.length > 0 && passwordLongEnough && passwordsMatch;

    function getValidationHint() {
        if(confirmPassword.length > 0 && !passwordsMatch) {
            return "Passwords do not match.";
        }
        if(newPassword.length > 0 && !passwordLongEnough) {
            return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
        }
        return `Use at least ${MIN_PASSWORD_LENGTH} characters. You'll be signed out after saving.`;
    }

    async function handlePasswordChange(event) {
        event.preventDefault();
        if(!canSubmit) return;
        setIsLoading(true);
        await changePassword(getUser().userId, oldPassword, newPassword);
        removeUserSession();
        props.setErrorMessage("Password changed successfully. Please log in with your new password.");
        props.setErrorStatus("success-message");
        props.setShowError(true);
        props.history.push('/login');
        setIsLoading(false);
    }

    const hintIsError = (confirmPassword.length > 0 && !passwordsMatch)
        || (newPassword.length > 0 && !passwordLongEnough);

    return (
        <div className="change-password-page">
            <header className="change-password-header">
                <h1>Change Password</h1>
                <p className="change-password-subtitle">
                    Choose a new password for your account. For security, you'll need to sign in again after saving.
                </p>
            </header>

            <div className="change-password-panel">
                <form className="change-password-form" onSubmit={handlePasswordChange}>
                    <FormGroup controlId="oldPassword">
                        <ControlLabel>Current Password</ControlLabel>
                        <FormControl
                            autoFocus
                            type="password"
                            autoComplete="current-password"
                            value={oldPassword}
                            onChange={e => setOldPassword(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup controlId="newPassword">
                        <ControlLabel>New Password</ControlLabel>
                        <FormControl
                            type="password"
                            autoComplete="new-password"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup controlId="confirmPassword">
                        <ControlLabel>Confirm New Password</ControlLabel>
                        <FormControl
                            type="password"
                            autoComplete="new-password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                        />
                    </FormGroup>
                    <p className={`change-password-hint ${hintIsError ? "change-password-hint--error" : ""}`}>
                        {getValidationHint()}
                    </p>
                    <div className="change-password-actions">
                        <LoaderButton
                            block
                            type="submit"
                            className="btn-brand-dark"
                            bsSize="large"
                            isLoading={isLoading}
                            disabled={!canSubmit}
                        >
                            Change Password
                        </LoaderButton>
                    </div>
                </form>
            </div>
        </div>
    );
}
